import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideAppInitializer } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';


import { AuthService, ClientLogService, CommonCheckService, EnvironmentService, FoxxylibSwaggerGenInterceptor, GuiService, LipoMessageService, NovitaetenLookupService } from 'FoxxyLib';
import { OAuthModule, OAuthService, provideOAuthClient } from 'angular-oauth2-oidc';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MetaReducer, provideStore, StoreModule } from '@ngrx/store';
import { reduceUser } from './store/user/reducer';
import { provideStoreDevtools, StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule, provideEffects } from '@ngrx/effects';
import { UserEffects } from './store/user/effect';

import { AsyncPipe, CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';


import { IsAuthenticatedGuardSort } from '@sortapp/guards/is-authenticated.guard';

import { providePrimeNG } from 'primeng/config';
import Nora from '@primeuix/themes/nora';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app-routing.module';
import { reduceNavigation } from './store/navigation/reducer';
import { notificationfeatureName, NotificationsEffects, reducerNotification } from './+notifications/store';
import { intializeApp } from './app-init';
import { SignalMessageService } from './common/services/signalmessage.service';
import { SignalRService } from './common/services/signalr.service';
import { IsAuthenticatedGuard } from './guards/is-authenticated.guard';
import { navigationfeatureName } from './store/navigation/state';
import { TaskListModule } from './+task-list/task-list.module';
import { featureNameTasklist, reducerTasklist, TasklistEffects } from './+task-list/store';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppModule } from './app.module';
import Lieferantenportalpreset from '@app/LiefPreset';
import { userfeatureName } from './store/user/state';
import { AppState, reducers } from './store';
import { environment } from '@env/environment';
import { storeFreeze } from 'ngrx-store-freeze';
import { featureuserTaskName, reducerUserTasks, UserViewEffects } from './+userTasks/store';
import { LipoRouteReuseStrategy } from './common/services/lipo-reuse-strategy';
import { DisableControlDirective } from './common/directives/DisableFormControl';




export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [storeFreeze] : [];






export const appConfig: ApplicationConfig = {

  providers: [
    DecimalPipe, AsyncPipe, DatePipe,
    MessageService,
    LipoMessageService,
    DisableControlDirective,
    GuiService,
    provideRouter(routes),
    {
          provide: RouteReuseStrategy,
          useClass: LipoRouteReuseStrategy,
       },
    AppModule,
    CommonModule, AuthService, SignalMessageService, SignalRService,
    CommonCheckService, EnvironmentService, ClientLogService, IsAuthenticatedGuardSort,
    TaskListModule, DialogService, ConfirmationService,
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        // hie farbe geben
        preset: Lieferantenportalpreset,
        options: {
          darkModeSelector: '.lipo-dark-mode',
      }
      }
    }),

    IsAuthenticatedGuard,
    { provide: LOCALE_ID, useValue: 'de-DE' },

    provideAppInitializer(() => intializeApp()),

    provideOAuthClient(),
    provideHttpClient(),

    provideStore({ user: reduceUser, navigation: reduceNavigation }),

    provideEffects([NotificationsEffects, UserEffects]),

    provideStoreDevtools(),
    { provide: HTTP_INTERCEPTORS, useClass: FoxxylibSwaggerGenInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      // Store mit provideStore !!!!
      StoreModule.forRoot(reducers, { metaReducers }),
      StoreModule.forRoot({}),
      EffectsModule.forRoot([]),
      EffectsModule.forFeature([UserEffects, NotificationsEffects]),
      StoreModule.forFeature(userfeatureName, reduceUser),
      StoreModule.forFeature(notificationfeatureName, reducerNotification),
      StoreModule.forFeature(navigationfeatureName, reduceNavigation),
      StoreModule.forFeature(featureNameTasklist, reducerTasklist),
      EffectsModule.forFeature([TasklistEffects]),
      StoreModule.forFeature(featureuserTaskName, reducerUserTasks),
      EffectsModule.forFeature([UserViewEffects]),

      StoreDevtoolsModule.instrument({
        maxAge: 25,
        logOnly: true,
      }),
      TranslateModule.forRoot({
        defaultLanguage: 'de'
      })


    )

  ]
};


